/**
 * Asking to join a team (an entitlement group): finding a team by name, and raising the request
 * (`Rws.AiInsights.Host.Requests.RequestEndpoints`). Open to every signed-in person.
 */
import { adminRequest, type AdminResult } from "./adminApi";

/** One team found by name. */
export interface TeamSearchResult {
  groupId: string;
  name: string;
  /** What the team sits under (its parent group or Department), to tell teams of the same name apart; null when nothing. */
  context: string | null;
  /** Whether the person is already a member, so they cannot ask to join it. */
  isMember: boolean;
}

/** The answer to raising a request to join a team. */
export interface JoinTeamRaised {
  requestId: string;
  status: string;
}

/** The fewest characters of a name the server searches for; shorter text finds nothing. */
export const MinimumTeamSearchLength = 3;

/** Calls `GET /api/entitlement/requests/join-group/search?q=`: up to ten teams whose name contains the text. */
export async function searchTeams(term: string): Promise<AdminResult<TeamSearchResult[]>> {
  return adminRequest<TeamSearchResult[]>(`/api/entitlement/requests/join-group/search?q=${encodeURIComponent(term)}`, { method: "GET" }, "team search");
}

/** Calls `POST /api/entitlement/requests/join-group`: asks the owner of the team to let the signed-in person join it. */
export async function raiseJoinTeamRequest(groupId: string, reason: string | null): Promise<AdminResult<JoinTeamRaised>> {
  return adminRequest<JoinTeamRaised>("/api/entitlement/requests/join-group", { method: "POST", body: JSON.stringify({ groupId, reason }) }, "join team request");
}
